import React from 'react'
import { Async as Select } from 'react-select'

const path = window.blocksPath || ''

const BlockSelect2 = ({ block, editMode, editModal, onSelect2Block, onUnselect2Block }) => (
  <Select
    cacheOptions
    isClearable
    defaultOptions
    defaultValue={block?.id ? { id: block.id, text: block.name } : undefined }
    getOptionLabel={({ text }) => text}
    getOptionValue={({ id }) => id}
    loadOptions={async inputValue => {
      const response = await fetch(`${path}.json?${new URLSearchParams({ q: inputValue }).toString()}`)
      const blocks = await response.json()

      return blocks
    }}
    isDisabled={!editMode && editModal}
    placeholder={I18n.t('vehicle_journeys.vehicle_journeys_matrix.affect_block')}
    onChange={(block, meta) => {
      switch(meta.action) {
        case 'select-option':
          onSelect2Block({ id: block.id, name: block.text })
          break
        case 'deselect-option':
        case 'clear':
          onUnselect2Block()
          break
      }
    }}
    styles={{
      control: (provided) => ({
        ...provided,
        minHeight: '51px',
        height: '51px'
      }),
      menu: base => ({ ...base, zIndex: 2000 })
    }}
  />
)

export default BlockSelect2
